import { NutrientsGroup } from '@/models/Ingredient/NutrientUnitList';
import SystemConfigurationRepository from '@/utils/API/SystemConfigurationRepository';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { NUTRIENTS_FETCH } from '../ActionTypes';
import { NUTRIENTS_SET_STATE } from '../MutationTypes';

export interface NutrientsState {
  nutrientSourceGroup: NutrientsGroup | null;
}

const state: NutrientsState = {
  nutrientSourceGroup: null,
};

const actions: ActionTree<NutrientsState, any> = {
  [NUTRIENTS_FETCH]({ commit }) {
    return new Promise((resolve, reject) => {
      SystemConfigurationRepository.listNutrients()
        .then((response) => {
          const nutrients = response.data.result;
          commit(NUTRIENTS_SET_STATE, nutrients);
          resolve(nutrients);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const mutations: MutationTree<NutrientsState> = {
  [NUTRIENTS_SET_STATE](state, nutrients: NutrientsGroup) {
    state.nutrientSourceGroup = nutrients;
  },
};

const getters: GetterTree<NutrientsState, any> = {
  getNutrients: (state) => state.nutrientSourceGroup,
};

export const NutrientsModule = {
  state,
  actions,
  getters,
  mutations,
};
